<template>

  <hr class="border-grey" />

</template>

<script>

import Field from './_Field'

export default {
  name: "ModuleFormFieldSeparator",
  extends: Field,
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
</style>
